import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CheckedUser = function CheckedUser(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M56.6667 80C44.7292 80 35 70.2708 35 58.3333C35 46.3958 44.7292 36.6667 56.6667 36.6667C68.6042 36.6667 78.3333 46.3958 78.3333 58.3333C78.3333 70.2708 68.6042 80 56.6667 80ZM56.6667 40C46.5625 40 38.3333 48.2292 38.3333 58.3333C38.3333 68.4375 46.5625 76.6667 56.6667 76.6667C66.7708 76.6667 75 68.4375 75 58.3333C75 48.2292 66.7708 40 56.6667 40Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.6667 36.6667C22.4792 36.6667 15 29.1875 15 20C15 10.8125 22.4792 3.33333 31.6667 3.33333C40.8542 3.33333 48.3333 10.8125 48.3333 20C48.3333 29.1875 40.8542 36.6667 31.6667 36.6667ZM31.6667 6.66667C24.3125 6.66667 18.3333 12.6458 18.3333 20C18.3333 27.3542 24.3125 33.3333 31.6667 33.3333C39.0208 33.3333 45 27.3542 45 20C45 12.6458 39.0208 6.66667 31.6667 6.66667Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M55 69.0208L42.8125 56.8333L45.1667 54.4792L55 64.3125L68.1667 51.1458L70.5208 53.5L55 69.0208Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.4165 71.6667H1.6665V70C1.6665 53.4583 15.1248 40 31.6665 40C35.7498 40 39.7082 40.8125 43.4373 42.3958L42.1248 45.4583C38.8123 44.0417 35.2915 43.3333 31.6665 43.3333C17.5207 43.3333 5.9165 54.3958 5.0415 68.3333H40.4165V71.6667Z",
      fill: color
    })]
  });
};
export default CheckedUser;